module.exports = __webpack_public_path__ + "assets/img/chartCard-bg.4b56469f.svg";